/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { Switch } from "@mui/material";
import { alpha, styled } from '@mui/material/styles';
import { green } from '@mui/material/colors';
import "../css/itemavilibility.css";
import { openDB } from "idb";
import Context from "../context/context";
import styles from "../css/SetupForm.module.css";
import SchemeStyles from '../css/ReferenceScheme.module.css'
import { CancelRounded, Inventory2Rounded as InventoryIcon } from '@mui/icons-material';

const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: green[500],
    '&:hover': {
      backgroundColor: alpha(green[500], theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: green[500],
  },
}));

export default function ItemAvilibility({ isItemAvilableOpen, setIsItemAvilableOpen }) {

  const context = useContext(Context);
  const { generateMenues, updateUnSync, showWarning } = context;
  const [itemsData, setItemsData] = useState([])
  const [categoryFilter, setCategoryFilter] = useState("")
  const [itemFilter, setItemFilter] = useState("")
  const [categoryDBData, setCategoryDBData] = useState([])
  const [categoryData, setCategoryData] = useState([])
  const [newItemData, setNewItemData] = useState([])

  useEffect(() => {
    const getData = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const tx = db.transaction("category", "readwrite").objectStore("category");
      const category = await tx.getAll()
      setCategoryDBData(category)
      console.log("-----------------", "category", category)
    }
    getData()
  }, [])

  useEffect(() => {
    const getData = async () => {
      setCategoryData(categoryDBData?.map((b, index) => {
        // console.log(itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length !== 0 && itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length === itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER && a?.outlet_wise_item_details[0]?.other_details?.item_availability === "1")?.length, b.category_name)
        return {
          ...b,
          OnButton: itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length !== 0 && itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length === itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER && a?.outlet_wise_item_details[0]?.other_details?.item_availability === "1")?.length,
          OffButton: itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length === 0 || itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length === itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER && a?.outlet_wise_item_details[0]?.other_details?.item_availability === "0")?.length,
          SomeButton: (itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length !== 0 && itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length === itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER && a?.outlet_wise_item_details[0]?.other_details?.item_availability === "1")?.length === false)
            && (itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length === 0 || itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER)?.length === itemsData?.filter(a => a?.category_uuid === b?.IDENTIFIER && a?.outlet_wise_item_details[0]?.other_details?.item_availability === "0")?.length === false),
        }
      }));

    };
    getData();
  }, [itemsData, categoryDBData]);

  useEffect(() => {
    const getData = async () => {
      let DBOpenReq = indexedDB.open(
        "FoodDo",
        +localStorage.getItem("IDBVersion") || 1
      );
      DBOpenReq.addEventListener("error", (err) => {
        console.warn(err);
      });
      DBOpenReq.addEventListener("success", (ev) => {
        let tx = ev.target.result.transaction("item", "readwrite");
        let store = tx.objectStore("item");
        let getReq = store.getAll();
        getReq.onsuccess = (outletReq) => {
          setItemsData(outletReq.target.result
          )
        }
      })
    }
    getData();
  }, []);

  const onButtonClick = async (category, value) => {
    setItemsData([
      ...itemsData.filter(item1 =>
        (item1.category_uuid !== category.category_uuid)),
      ...itemsData.filter(item1 =>
        (item1.category_uuid === category.category_uuid)).map(item1 => ({
          ...item1, outlet_wise_item_details: [{
            ...item1.outlet_wise_item_details[0],
            other_details: {
              ...item1.outlet_wise_item_details[0].other_details,
              item_availability: value
            }
          }]
        }))])

    let data = itemsData.filter(item1 =>
      (item1.category_uuid === category.category_uuid))
      .map(item1 =>
      ({
        ...item1, outlet_wise_item_details: item1.outlet_wise_item_details
          .map(item2 =>
            ({ ...item2, other_details: { ...item2.other_details, item_availability: value } }))
      }))

    setNewItemData([...newItemData, ...data])
    // console.log("itemData--[]", newItemData);

  }

  const onChangeHandler = (item, value) => {
    // setItemsData([...itemsData.map(item1 => {
    //   if (item1.item_uuid === item.item_uuid) {
    //     return { ...item1, outlet_wise_item_details: item1.outlet_wise_item_details.map(item2 => ({ ...item2, other_details: { ...item2.other_details, item_availability: item2.other_details.item_availability === "0" ? "1" : "0" } })) }
    //   } return item1
    // })])
    console.log("value", value)
    setItemsData([
      ...itemsData.filter(item1 =>
        (item1.item_uuid !== item.item_uuid)),
      ...itemsData.filter(item1 =>
        (item1.item_uuid === item.item_uuid)).map(item1 => ({
          ...item1, outlet_wise_item_details: [{
            ...item1.outlet_wise_item_details[0],
            other_details: {
              ...item1.outlet_wise_item_details[0].other_details,
              item_availability: value
            }
          }]
        }))])
    let data = itemsData.filter(item1 => (item1.item_uuid === item.item_uuid)).map(item1 =>
    ({
      ...item1, outlet_wise_item_details: item1.outlet_wise_item_details.map(item2 =>
        ({ ...item2, other_details: { ...item2.other_details, item_availability: value } }))
    }))
    setNewItemData([...newItemData, ...data])


  }

  const handleUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const ndata = {
      IDENTIFIER: "item_availability:" + data.item_uuid,
      RECON_TIME: new Date().getTime().toString(),
      item_uuid: data.item_uuid,
      item_availability: data.outlet_wise_item_details[0].other_details.item_availability
    };
    const tx = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");

    await tx.put(ndata);
    await handleItemReconciliation(ndata)
    updateUnSync()
  };

  const handleItemReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const itemsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "item_availability"
    );
    if (itemsJsonExists) {
      const items = itemsJsonExists?.details?.filter(
        (item) => item.item_uuid !== data.item_uuid
      );
      const editData = {
        ...itemsJsonExists,
        details: [
          ...items,
          {
            item_uuid: data.item_uuid,
            RECON_TIME: data.RECON_TIME,
            item_availability: data.item_availability
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "item_availability",
        details: [
          {
            item_uuid: data.item_uuid,
            RECON_TIME: data.RECON_TIME,
            item_availability: data.item_availability

          },
        ],
      };
      await tx.add(newdata);
    }
  };

  const HandelSubmit = async () => {
    setIsItemAvilableOpen(!isItemAvilableOpen);
    if (newItemData.length) {

      localStorage.setItem("refresh_status", 1)
      console.log("newItemArray", newItemData)
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const tx = await db
        .transaction("item", "readwrite")
        .objectStore("item");
      let updateData = await newItemData.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.item_uuid === value.item_uuid
        ))
      )
      await updateData.map(async (item, index) => {
        await tx.put(item)
        await handleUnsyncedFile(item)
        console.log("newItemData", item)
        if (updateData.length === index + 1) {
          generateMenues()
          localStorage.setItem("refresh_status", 0)
        }
      })
    }
  }

  const [stockPopupItem, setStockPopupItem] = useState(null)

  return (
    <>
      <div className="itemavilablelity">
        <div className="itemavilabelitycontainer">
          <div className="itemavilablelity_header">
            <h2>Item Availablity</h2>
          </div>

          <div className="availablecontainer">
            <div className="itemavilablelitybox">
              <input
                className={styles.numberInput}
                type="text"
                name="item_filter"
                value={itemFilter}
                onChange={(e) => { setItemFilter(e.target.value); }}
                placeholder="Items Filter"
                style={{ width: "80%", margin: "10px 0" }}
              />
              <div className="items_table">
                <table className="f6 w-100 center" cellSpacing="0">
                  <thead className="lh-copy">
                    <tr className="white">
                      <th className="pa3 bb b--black-20 ">Item</th>
                      <th className="pa3 bb b--black-20 ">Category</th>
                      <th className="pa3 bb b--black-20 ">Available</th>
                      <th className="pa3 bb b--black-20 ">Stock</th>
                    </tr>
                  </thead>
                  <tbody className="lh-copy">
                    {itemsData.sort((a, b) => a.item_name.localeCompare(b.item_name)).filter(a => itemFilter !== "" ? a.item_name.toLowerCase().includes(itemFilter.toLowerCase()) : true).map((item, index) => (
                      <tr key={index}>
                        <td className="ph3 bb b--black-20 tc bg-white">{item.item_name}</td>
                        <td className="ph3 bb b--black-20 tc bg-white">{categoryData.find(a => a.IDENTIFIER === item.category_uuid)?.category_name || "-"}</td>
                        <td className="ph3 bb b--black-20 tc bg-white">
                          <GreenSwitch
                            checked={item?.outlet_wise_item_details[0]?.other_details?.item_availability === "1"}
                            onChange={(e) => onChangeHandler(item, item.outlet_wise_item_details[0]?.other_details?.item_availability === "1" ? "0" : "1")} />
                        </td>
                        <td className="ph3 bb b--black-20 tc bg-white" onClick={e => {
                          if (navigator.onLine)
                            setStockPopupItem(item)
                          else
                            showWarning({
                              message: 'Internet connection is required',
                              classname: 'active-red'
                            })
                        }}>
                          <InventoryIcon style={{ color: '#4ec353' }} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="itemavilablelitybox">
              <input
                className={styles.numberInput}
                type="text"
                name="category_filter"
                placeholder="Category filter"
                style={{ width: "80%", margin: "10px 0" }}
                value={categoryFilter}
                onChange={(e) => { setCategoryFilter(e.target.value); }}
              />
              <div className="items_table">
                <table className="f6 w-100 center" cellSpacing="0">
                  <thead className="lh-copy">
                    <tr className="white">
                      <th className="pa3 bb b--black-20 ">Category</th>
                      <th className="pa3 bb b--black-20 " >Available</th>
                    </tr>
                  </thead>
                  <tbody className="lh-copy">
                    {categoryData.sort((a, b) => a.category_name.localeCompare(b.category_name)).filter(a => categoryFilter !== "" ? a.category_name.toLowerCase().includes(categoryFilter.toLowerCase()) : true)
                      .map((item, index) => (
                        <tr key={index}>
                          <td className="ph3 bb b--black-20 tc bg-white">{item.category_name}</td>
                          <td className="ph3 bb b--black-20 tc bg-white" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div
                              className="conditionalButton"
                              style={item?.OffButton ? { backgroundColor: "red" } : { backgroundColor: "black" }}
                              onClick={() => onButtonClick(item, "0")}>
                              Off
                            </div>
                            <div
                              className="conditionalButton"
                              style={item?.SomeButton ? { backgroundColor: "rgb(255, 198, 11)" } : { backgroundColor: "black" }}>
                              Some
                            </div>
                            <div
                              className="conditionalButton"
                              style={item?.OnButton ? { backgroundColor: "green" } : { backgroundColor: "black" }}
                              onClick={() => onButtonClick(item, "1")}>
                              On
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div onClick={HandelSubmit}>
            <button className="savebtn">
              Done
            </button>
          </div>
        </div>
      </div>
      {stockPopupItem ? <ItemStock item={stockPopupItem} updateUnSync={updateUnSync} close={() => setStockPopupItem(null)} /> : ''}
    </>
  );
}

const ItemStock = ({ close, item, updateUnSync }) => {

  const server = 'https://api.myfooddo.com'
  // const server = 'http://localhost:5000'
  const [stockQtys, setStockQtys] = useState({})

  useEffect(() => {
    const api = async () => {
      const url = `${server}/stocks/getStock/${item.item_uuid}/${localStorage.getItem('outlet_uuid')}`;
      let stock_doc = await fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });
      if (stock_doc.ok) {
        stock_doc = await stock_doc.json();
        setStockQtys({
          alert_qty: stock_doc.alert_qty,
          available_qty: stock_doc.available_qty
        })
      }
    }
    api()
  }, [])

  const submitHandler = async () => {
    close()

    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");

    tx.put({
      BACKUP: 0,
      IDENTIFIER: `item_stock:${item.item_uuid}`,
      outlet_uuid: localStorage.getItem('outlet_uuid'),
      item_uuid: item.item_uuid,
      type: 'POS',
      ...stockQtys
    })
    updateUnSync()
  }

  const inputHandler = e => setStockQtys({ ...stockQtys, [e.target.name]: +e.target.value })

  return (
    <div className={SchemeStyles.popupContainer} style={{ zIndex: '100', left: '-100px', width: '100vw' }}>
      <div className={SchemeStyles.popupBody}>
        <h2>Stock</h2>
        <div>
          <div className={SchemeStyles.formsContainer}>
            <form className='item-stock-input-div'>
              <label>Available QTY</label>
              <input type='number' name='available_qty' placeholder='Available Qty' value={stockQtys?.available_qty || ''} onChange={inputHandler} required />
              <label>Display alert at</label>
              <input type='number' name='alert_qty' placeholder='Alert qty' value={stockQtys?.alert_qty || ''} onChange={inputHandler} required />
            </form>
          </div>
          <button className={`${SchemeStyles.submitBtn} item-stock-save`} onClick={submitHandler}>Save</button>
        </div>
        <CancelRounded onClick={close} className={SchemeStyles.close} />
      </div>
    </div>
  )
}